import React, { Component } from 'react'
import '../styles/SitesListView.css'
import InputSearchWidget from '../widgets/InputSearchWidget'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APISupplyPlanRequest from '../api/APISupplyPlanRequest'
import APISiteRequest from '../api/APISiteRequest'
import APICalendar from '../api/APICalendar'

class SupplyPlanListView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: JSON.parse(localStorage.getItem("siteId")),
		}
		this.viewDetails = this.viewDetails.bind(this)
		this.addSupplyPlan = this.addSupplyPlan.bind(this)
		this.getAllSupplyPlanBySiteId = this.getAllSupplyPlanBySiteId.bind(this)
		this.getSupplyPlanById = this.getSupplyPlanById.bind(this)
		this.getProspectiveBuyerById = this.getProspectiveBuyerById.bind(this)
	}

	viewDetails(id, name) {
		this.props.viewDetails("view-details", null, name, id)
	}

	componentWillMount() {
		this.setState({showActivityIndicator: true})
		this.getAllSupplyPlanBySiteId()
		// var plan = APISupplyPlanRequest.getAllSupplyPlanBySiteId(this.state.accessToken, this.state.siteId)
		// plan.then((response) => {
		// 	if(response.status === "FAILED") {
		// 		this.setState({showActivityIndicator: false})
		// 		return
		// 	}
		// 	console.log('getAllSupplyPlanBySiteId', response)
		// 	this.setState({plans: response.results.rows, showActivityIndicator: false})
		// })
	}

	getAllSupplyPlanBySiteId() {
		var plan = APISupplyPlanRequest.getAllSupplyPlanBySiteId(this.state.accessToken, this.state.siteId)
		plan.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			console.log('getAllSupplyPlanBySiteId', response)
			const plans = []
			const count = response.results.count
			let increment = 0
			response.results.rows.map((item, i) => {
				this.getSupplyPlanById(item.supply_plan_id, (targetMarket) => {
					console.log('getSupplyPlanById-->', targetMarket)
					if(targetMarket.length > 0) {
						this.getProspectiveBuyerById(targetMarket[0], (marketName) => {
							console.log('market name', marketName)
							item['target_market_name'] = marketName
							plans.push(item)
							increment++
							if(increment === count) {
								console.log('plans', plans)
								plans.sort((a, b) => {
									return(a.crop.localeCompare(b.crop))
								})
								this.setState({plans: plans, showActivityIndicator: false})
							}
						})
					}
					else {
						plans.push(item)
						increment++
					}
					console.log(increment, count)
					if(increment === count) {
						console.log('plans 1', plans)
						plans.sort((a, b) => {
							return(a.crop.localeCompare(b.crop))
						})
						console.log('plans 2', plans)
						this.setState({plans: plans, showActivityIndicator: false})
					}
				
				})
			})
		})
	}

	getSupplyPlanById(id, callback) {
		const req = APISupplyPlanRequest.getSupplyPlanById(this.state.accessToken, id)
		req.then((response) => {
			console.log('getSupplyPlanById', response)
			if(response.status === "FAILED") {
				return
			}
			// NOTE: include buyer name
			callback(response.results.targetMarket)
		})
	}

	getProspectiveBuyerById(tb, callback) {
		const apiReq = APISiteRequest.getProspectiveBuyerById(this.state.accessToken, tb.mcs_prospective_buyer_id)
		apiReq.then((response) => {
			console.log('getProspectiveBuyerById', response)
			if(response.status === "FAILED") {
				return
			}
			callback(response.results.target_market_name)
			// this.setState({
			// 	buyer: response.results.target_market_name,
			// 	prospectiveBuyerId: tb.mcs_prospective_buyer_id,
			// 	targetMarketId: tb.sp_target_market_id
			// })
		})
	}

	addSupplyPlan() {
		this.props.addSupplyPlan("add-supply-plan")
	}

	render() {
		return(<div id="sites-listview">
			<div id="sl-listview"><ListView data={this.state.plans}
				addSupplyPlan={this.addSupplyPlan}
				viewDetails={this.viewDetails} />
			</div>
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>)
	}
}

class ListView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			searchLabel: (props.data != null)? props.data.length + " SUPPLY PLAN(S)": "0 SUPPLY PLAN",
			listItems: [],
			addSupplyPlan: props.addSupplyPlan,
			roleId: props.roleId
		}
		this.viewDetails = this.viewDetails.bind(this)
	}

	viewDetails(id, name) {
		this.props.viewDetails(id)
	}

	componentDidUpdate(prevProps) {
		if(prevProps.data != this.props.data) {
			const listItems = []
			if(this.props.data == null) {
				return
			}
			if(this.props.data.length <= 0) {
				return
			}
			for(const v of this.props.data) {
				listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
			}
			this.setState({
				searchLabel:  (this.props.data != null)? this.props.data.length + " SUPPLY PLAN(S)": "0 SUPPLY PLAN",
				listItems: listItems
			})
		}
	}

	render() {
		return(<div className="site-lv">
			<div className="flv-top">
				<InputSearchWidget placeholder="SEARCH" cStyle={{'width': '285px'}}
					onSearchClick={(value) => {
						if(this.props.data == null) {
							return
						}
						const sr = searchString(value, this.props.data)
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
						}
						this.setState({
							searchLabel:  sr.length + " SUPPLY PLAN(S)",
							listItems: listItems
						})
					}}
					onEnterPress={(value) => {
						if(this.props.data == null) {
							return
						}
						const sr = searchString(value, this.props.data)
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
						}
						this.setState({
							searchLabel:  sr.length + " SUPPLY PLAN(S)",
							listItems: listItems
						})
					}} />
				<div className="flv-label"><div>{this.state.searchLabel}</div></div>
			</div>
			<div className="flv-header">
				<table className="flv-table-header">
					<col style={{width: '20%'}} />
					<col style={{width: '20%'}} />
					<col style={{width: '20%'}} />
					<col style={{width: '20%'}} />
					<col style={{width: '20%'}} />
					<tr>
						<th>CROP COMMITTED</th>
						<th>TOTAL VOLUME COMMITTED</th>
						<th>NAME OF BUYER</th>
						<th>DELIVERY START DATE</th>
						<th>DELIVERY END DATE</th>
						<div className="slv-grid-btn">
							<button className="green-two" onClick={(e) => {
								this.state.addSupplyPlan()
							}}>ADD</button>
						</div>
					</tr>
				</table>
			</div>
			<div className="flv-items">{this.state.listItems}</div>
			{this.state.listItems.length < 1 && <div className="flv-result"><div>NO RESULT</div></div>}
		</div>)
	}
}

function ListItem(props) {
	return(<div className="fc-list-item">
			<table className="fc-table-data">
			<col style={{width: '20%'}} />
			<col style={{width: '20%'}} />
			<col style={{width: '20%'}} />
			<col style={{width: '20%'}} />
			<col style={{width: '20%'}} />
				<tr>
					<td>{props.data.crop}</td>
					<td>{`${props.data.target_volume}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</td>
					<td>{props.data.target_market_name}</td>
					<td>{formatDate(props.data.start_date)}</td>
					<td>{formatDate(props.data.end_date)}</td>
					<div className="flv-grid-btn"><button className="btn-view-details" onClick={(e) => {
							props.viewDetails(props.data.supply_plan_id)
						}}>VIEW DETAILS</button>
					</div>
				</tr>
			</table>
	</div>)
}

const searchString = (str, data) => {
	if(data.length < 1) {
		return
	}
	if(str == null) {
		str = ""
	}
	const list = []
	for(const v of data) {
		const name = v.name
		if(name.toLowerCase().includes(str.toLowerCase()) || v.city.toLowerCase().includes(str.toLowerCase()) || v.province.toLowerCase().includes(str.toLowerCase())) {
			list.push(v)
		}
	}
	return(list)
}

const formatDate = (dt) => {
	const date = new Date(dt)
	const month = APICalendar.getMonthString(date.getMonth())
	const v = month + " " + date.getDate() + ", " + date.getFullYear()
	return(v)
}

export default SupplyPlanListView
